exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.ant-table-tbody .ant-table-row td[data-v-228f7c62]{\n  padding-top:10px;\n  padding-bottom:10px;\n}\n", ""]);

// exports
